<div (document:keydown.escape)="pressEscape()" class="datiq-modal-bg">
    <div (click)="clickBg()" class="datiq-modal-bg__background"></div>
    <div class="datiq-modal-bg__container">
        <ng-content select="[datiq-modal-container]"></ng-content>
    </div>
</div>
